/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Classifier } from './classifier';


/**
 * Клиент макробанка
 */
export interface Client { 
    /**
     * Идентификатор
     */
    id?: number;
    /**
     * Имя
     */
    name?: string | null;
    oid?: number;
    /**
     * Описание
     */
    description?: string | null;
    /**
     * Тип клиента
     */
    type?: string | null;
    /**
     * Категория тарифа
     */
    tariffCategoryId?: number;
    /**
     * Код идентификации 1
     */
    identityCode1?: string | null;
    /**
     * Код идентификации 2
     */
    identityCode2?: string | null;
    /**
     * Код идентификации 3
     */
    identityCode3?: string | null;
    /**
     * Идентификатор пасспорта
     */
    passportId?: string | null;
    /**
     * Дата рождения
     */
    birthDate?: string | null;
    /**
     * Признак удаления
     */
    deleted?: boolean;
    /**
     * Статус клиента
     */
    status?: string | null;
    classifiersString?: string | null;
    /**
     * Classifiers ids array
     */
    classifiers?: Array<Classifier> | null;
}

